<template>
  <Modal title="赠送优惠券" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="formInfo"  :model='formInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
          <FormItem label="优惠券："  prop="coupon_id">
            <Select v-model="formInfo.coupon_id" class="perW100">
              <Option :value="0">请选择</Option>
              <Option v-for="item in coupinInfo" :value="item.id" :key="item.id">
                {{item.name}}
              </Option>
            </Select>
          </FormItem>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('formInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { getAllCoupon, addCoupon } from '@/api/user'
export default {
  name: 'giveEdit',
  data () {
    return {
      isShow: false,
      coupinInfo: [],
      formInfo: {
        user_id: 0,
        coupon_id: 0
      },
      ruleValidate: {
        coupon_id: [
          { required: true, message: '请选择优惠券', trigger: 'change', type: 'number', min: 1 }
        ]
      }
    }
  },
  created () {
    this.getAllCoupon()
  },
  methods: {
    handle (status) {
      this.isShow = false
    },
    handleOk (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          addCoupon(this.formInfo).then(res => {
            let msg = '发放成功'
            if (res.code === 200) {
              this.$Message.success(msg)
              this.isShow = false
              this.$emit('closeModal')
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    getAllCoupon () {
      getAllCoupon().then(res => {
        this.coupinInfo = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
